import {
  DEFAULT_JOURNEY_CANVAS_HEIGHT,
  DEFAULT_JOURNEY_CANVAS_WIDTH,
  JOURNEY_MAX_ZOOM,
  JOURNEY_MIN_ZOOM,
} from '../../../../support/journeyMap/constants';

export const CANVAS_DEFAULT_WIDTH = DEFAULT_JOURNEY_CANVAS_WIDTH;
export const CANVAS_DEFAULT_HEIGHT = DEFAULT_JOURNEY_CANVAS_HEIGHT;

export const MIN_ZOOM = JOURNEY_MIN_ZOOM;
export const MAX_ZOOM = JOURNEY_MAX_ZOOM;

export const PROVIDER_OPTIONS = [
  { label: 'Cyber Academy', value: 'Cyber Academy', endpoint: 'db/ai-snackable-course/' },
  { label: 'Moodle', value: 'Moodle', endpoint: 'db/ai-snackable-course/' },
  { label: 'Mindtickle', value: 'Mindtickle', endpoint: 'db/ai-snackable-course/' },
];